import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { configure_getting_started_progress } from "../../../actions/globalAction";
import "./content.scss";
import { Link } from "react-router-dom";
import { Dimmer, Loader } from "semantic-ui-react";

import { ReactComponent as Ownedpageanalytics } from "../../../assets/svg/facebook-insight.svg";
import { setActiveModule } from "../../../actions/sideBarActions";

const SMRAnalytics = () => {
    const dispatch = useDispatch();
    // useEffect(() => {
    //     let obj = {
    //         // total_sections: 33,
    //         progress_config: {
    //             smr_analytics: 1,
    //         },
    //     };

    //     dispatch(configure_getting_started_progress(obj));
    // }, []);
    const configureProgress = () => {
        let obj = {
            // total_sections: 33,
            progress_config: {
                smr_analytics: 1,
            },
        };
        localStorage.setItem("activeModule", "Response");
        dispatch(setActiveModule("Response"));
        dispatch(configure_getting_started_progress(obj));
    };
    return (
        <>
            <div className="gs_content">
                <div className="left_content">
                    <div className="gs_header">
                        {/* <Icon name="user" size="large" className="icon_content" color="#268af6" width="20px" height="20px" /> */}
                        <Ownedpageanalytics className="icon_content fill_svg" />
                        <span className="content_title">Response Analytics</span>
                    </div>
                    <div className="text_content">
                        <p>{`Use this section to analyze your agent and team level metrics.`}</p>
                        <p>
                            You can view service levels, first response time, resolution time etc. These are available for the whole team for a specific agent.
                        </p>
                        <p>
                            Use filters to change duration or sort the data based on date and sentiment. You can also download the charts in png or jpg format.
                            This section can only be accessed if you have manager access to the module
                        </p>
                        {/* <p>{`Some of the reports and other functionality use your time zone to work properly.  You can control your time zone from here.`}</p> */}
                    </div>
                    <Link to="/social-response/dashboard">
                        <button className="gs_link" onClick={() => configureProgress()}>
                            Explore
                        </button>
                    </Link>
                </div>
                <div className="right_content">
                    <div id="gs_loader">
                        <Dimmer inverted active>
                            <Loader size="big skiptranslate">Loading</Loader>
                        </Dimmer>
                    </div>
                    <iframe
                        width="320px"
                        height="200px"
                        src="https://www.youtube.com/embed/s99CmyYSe9k"
                        title=""
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                        allowFullScreen
                        onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                        className="content_video"></iframe>
                    {/* <img className="content-img" src={profileImg} width="350px" height="200px" /> */}
                </div>
            </div>
        </>
    );
};

export default SMRAnalytics;
